import _classCallCheck from "/Volumes/DustedRepos/htb/htb-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Volumes/DustedRepos/htb/htb-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/Volumes/DustedRepos/htb/htb-gatsby/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Volumes/DustedRepos/htb/htb-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Volumes/DustedRepos/htb/htb-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import { appendClassName } from "../view-helpers";

var LayoutSidebar = /*#__PURE__*/function (_React$Component) {
  _inherits(LayoutSidebar, _React$Component);

  var _super = _createSuper(LayoutSidebar);

  function LayoutSidebar(props) {
    var _this;

    _classCallCheck(this, LayoutSidebar);

    _this = _super.call(this, props);

    _this.toggleSidebar = function () {
      _this.setState(function (_ref) {
        var isSidebarToggled = _ref.isSidebarToggled;
        return {
          isSidebarToggled: !isSidebarToggled
        };
      });
    };

    _this.renderToggleButton = function (label) {
      if (!_this.props.children) return null;
      return React.createElement("button", {
        hidden: true,
        type: "button",
        className: "sui-layout-sidebar-toggle",
        onClick: _this.toggleSidebar
      }, label);
    };

    _this.state = {
      isSidebarToggled: false
    };
    return _this;
  }

  _createClass(LayoutSidebar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children;
      var isSidebarToggled = this.state.isSidebarToggled;
      var classes = appendClassName(className, isSidebarToggled ? "".concat(className, "--toggled") : null);
      return React.createElement(React.Fragment, null, this.renderToggleButton("Show Filters"), React.createElement("div", {
        className: classes
      }, this.renderToggleButton("Save Filters"), children));
    }
  }]);

  return LayoutSidebar;
}(React.Component);

export default LayoutSidebar;